'use client';

import { Box } from '@mui/material';

import { env } from '@/env';

import { Or2Link } from '../navigation/Or2Link';
import { Or2SupportLink } from '../navigation/Or2SupportLink';

export const Footer = () => {
  const thisYear = new Date().getFullYear();

  return (
    <Box sx={{ textAlign: 'center', fontSize: 12, padding: 1 }}>
      <Or2Link isExternal href="https://status.governorhub.com">
        System status
      </Or2Link>
      <div>
        <Or2SupportLink>{env.NEXT_PUBLIC_SUPPORT_EMAIL}</Or2SupportLink>
      </div>
      <div>
        {`© `}
        <Or2Link isExternal href="https://thekeysupport.com">
          {`The Key Support Services Ltd`}
        </Or2Link>
        {` ${thisYear}`}
      </div>
    </Box>
  );
};
